import React from 'react'
import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'
import { withRouter } from 'react-router-dom'
import Header from './Header'
import { pageTitle, getBackendFooter,getBSRSToken } from 'Lib'
import Routes from './Routes'
import Footer from './Footer'
import { Container } from 'semantic-ui-react'
import { findSettingInfo } from '../../setting/actions'
import { getSettingInfo } from '../../setting/selectors'

// export default () => (
//     <div>
//         <Header />
//         <Container style={{ minHeight: '219px',marginBottom: '5rem' }}>
//             <Routes />
//         </Container>
//         <Footer />
//     </div>
// )

class App extends React.Component {
    componentDidMount = () => {
        document.title = pageTitle;
    }
    render() {
        return (
            <div>
                <Header />
                <Container style={{ minHeight: '219px', marginBottom: '5rem' }}>
                    <Routes />
                </Container>
                <Footer setting={this.props.setting}/>
            </div>
        )
    }
}
// export default (App)
export default compose( 
    withRouter,
	connect(
		(state, props) => ({
			setting: getSettingInfo(state),
		}),
		(dispatch, history) => ({
			findSettingInfo() {
				dispatch(findSettingInfo())
			},
		})
	),
	lifecycle({
		componentDidMount() {
            if(!getBackendFooter() && getBSRSToken())
			this.props.findSettingInfo()
		},
	}),
)(App)


// WEBPACK FOOTER //
// ./src/features/ui/components/App.js